;(function () {
  if (customElements.get('product-siblings')) return

  class ProductSiblings extends HTMLElement {
    constructor() {
      super()
      this.moreButton = this.querySelector('.product-siblings__more-button')
      this.siblingsList = this.querySelector('.product-siblings__list')

      if (this.moreButton) {
        this.moreButton.addEventListener('click', this.showMoreItems.bind(this))
      }
    }

    showMoreItems() {
      if (!this.siblingsList) return

      // Find all hidden li elements in the list
      const hiddenItems = this.siblingsList.querySelectorAll('li.hidden')

      // Remove hidden class from all hidden items
      hiddenItems.forEach((item) => {
        item.classList.remove('hidden')
      })

      // Add hidden class to the more button container
      const moreButtonContainer = this.querySelector(
        '.product-siblings__item--hidden'
      )
      if (moreButtonContainer) {
        moreButtonContainer.classList.add('hidden')
      }
    }
  }

  // Register the custom element
  customElements.define('product-siblings', ProductSiblings)
})()
